export default __webpack_public_path__ + "static/media/login-background.f5d930d0.jpg";